import { combineReducers } from 'redux-immutable'

import topics from './topics'
import editions from './editions'

export default combineReducers({
  topics,
  editions
})
